import React from "react";
import { useSelector } from "react-redux";
import { getToolTip } from "../../../../utils/getToolTip";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const NetUnits = ({ qa }) => {
  const { netUnitsMTD, netUnitsMTDLink, netUnitsMTDChange } = useSelector(
    (state) => state.membershipUnits.membershipUnits.units
  );

  const state = useSelector((state) => state.membershipUnits.membershipUnits);
  const toolTip = getToolTip(state);

  return (
    <div className="content__el">
      <DataDisplay
        label="Net Units MTD"
        type="number"
        value={netUnitsMTD}
        url={netUnitsMTDLink}
        disableAnimation={qa}
        toolTipContent={toolTip}
        toolTipId="membershipNewUnitsToolTipMTD"
        changeProps={{
          changeValue: netUnitsMTDChange,
          toolTip: "Percentage change from previous month",
          showBorder: true
        }}
      />
    </div>
  );
};

export default NetUnits;
